'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useState } from 'react';
import useIsMounted from '@/hooks/useIsMounted';
import { backButton, biometry, closingBehavior, init, initData, isTMA, locationManager, mainButton, miniApp, secondaryButton, settingsButton, swipeBehavior, themeParams, useAndroidDeviceData, useLaunchParams, useRawInitData, useSignal, viewport } from '@tma.js/sdk-react';
import TelegramContext from '@/context/TelegramContext';
import LoadingScreen from '@/components/screens/LoadingScreen';
import SplashScreen from '@/components/screens/SplashScreen';
import Link from 'next/link';
import TelegramLink from '@/components/ui/social/TelegramLink';
import RedditLink from '@/components/ui/social/RedditLink';
import XLink from '@/components/ui/social/XLink';
function TelegramProviderContent(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const launchParams = useLaunchParams();
  const rawInitData = useRawInitData();
  const deviceInfo = useAndroidDeviceData();
  let t1;
  if ($[0] !== deviceInfo || $[1] !== launchParams || $[2] !== rawInitData) {
    t1 = {
      launchParams,
      rawInitData,
      deviceInfo
    };
    $[0] = deviceInfo;
    $[1] = launchParams;
    $[2] = rawInitData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = <TelegramContext.Provider value={t1}>{children}</TelegramContext.Provider>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export default function TelegramProvider(t0) {
  const $ = _c(39);
  const {
    children
  } = t0;
  const isMounted = useIsMounted();
  const [isReady, setIsReady] = useState(false);
  const isMiniAppMounted = useSignal(miniApp.isMounted);
  const isViewportMounted = useSignal(viewport.isMounted);
  const isThemeParamsMounted = useSignal(themeParams.isMounted);
  const isClosingBehaviorMounted = useSignal(closingBehavior.isMounted);
  const isSwipeBehaviorMounted = useSignal(swipeBehavior.isMounted);
  const isBackButtonMounted = useSignal(backButton.isMounted);
  const isMainButtonMounted = useSignal(mainButton.isMounted);
  const isSecondaryButtonMounted = useSignal(secondaryButton.isMounted);
  const isSettingsButtonMounted = useSignal(settingsButton.isMounted);
  const isLocationManagerMounted = useSignal(locationManager.isMounted);
  const isBiometryMounted = useSignal(biometry.isMounted);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  let t3;
  if ($[1] !== isBackButtonMounted || $[2] !== isBiometryMounted || $[3] !== isClosingBehaviorMounted || $[4] !== isLocationManagerMounted || $[5] !== isMainButtonMounted || $[6] !== isMiniAppMounted || $[7] !== isReady || $[8] !== isSecondaryButtonMounted || $[9] !== isSettingsButtonMounted || $[10] !== isSwipeBehaviorMounted || $[11] !== isThemeParamsMounted || $[12] !== isViewportMounted) {
    t2 = () => {
      const ready = (isMiniAppMounted || !miniApp.isSupported()) && isViewportMounted && isThemeParamsMounted && isClosingBehaviorMounted && (isSwipeBehaviorMounted || !swipeBehavior.isSupported()) && (isBackButtonMounted || !backButton.isSupported()) && isMainButtonMounted && (isSecondaryButtonMounted || !secondaryButton.isSupported()) && (isSettingsButtonMounted || !settingsButton.isSupported()) && (isLocationManagerMounted || !locationManager.isSupported()) && (isBiometryMounted || !biometry.isSupported());
      if (ready && !isReady) {
        if (miniApp.isSupported()) {
          miniApp.setHeaderColor("#3B82F6");
          miniApp.setBgColor("#0F172A");
          miniApp.setBottomBarColor("#00E5C8");
          miniApp.ready();
        }
        viewport.expand();
        viewport.requestFullscreen();
        setIsReady(true);
      }
    };
    t3 = [isMiniAppMounted, isViewportMounted, isThemeParamsMounted, isClosingBehaviorMounted, isSwipeBehaviorMounted, isBackButtonMounted, isMainButtonMounted, isSecondaryButtonMounted, isSettingsButtonMounted, isLocationManagerMounted, isBiometryMounted, isReady];
    $[1] = isBackButtonMounted;
    $[2] = isBiometryMounted;
    $[3] = isClosingBehaviorMounted;
    $[4] = isLocationManagerMounted;
    $[5] = isMainButtonMounted;
    $[6] = isMiniAppMounted;
    $[7] = isReady;
    $[8] = isSecondaryButtonMounted;
    $[9] = isSettingsButtonMounted;
    $[10] = isSwipeBehaviorMounted;
    $[11] = isThemeParamsMounted;
    $[12] = isViewportMounted;
    $[13] = t2;
    $[14] = t3;
  } else {
    t2 = $[13];
    t3 = $[14];
  }
  useEffect(t2, t3);
  if (!isMounted) {
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <LoadingScreen isBrowser={true} />;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    return t4;
  }
  if (!isTMA()) {
    let t4;
    let t5;
    let t6;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <br />;
      t5 = <span className="bg-linear-to-b from-secondary to-primary text-transparent bg-clip-text">Flock of Birds</span>;
      t6 = <br />;
      $[16] = t4;
      $[17] = t5;
      $[18] = t6;
    } else {
      t4 = $[16];
      t5 = $[17];
      t6 = $[18];
    }
    let t7;
    let t8;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <br />;
      t8 = <span className="bg-linear-to-b from-secondary to-primary text-transparent bg-clip-text">Way of Truth</span>;
      t9 = <br />;
      $[19] = t7;
      $[20] = t8;
      $[21] = t9;
    } else {
      t7 = $[19];
      t8 = $[20];
      t9 = $[21];
    }
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <h1 className="text-center text-3xl">You can find your{t4}{t5}{t6}and{t7}{t8}{t9}only on the freedom-loving<br /><span className="underline">Telegram</span> platform</h1>;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <Link href={new URL(process.env.NEXT_PUBLIC_TMA_DIRECT_LINK || "")} className="rounded-full bg-linear-to-b from-secondary to-primary px-5 py-3">Gain your freedom</Link>;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <h2 className="text-center text-2xl p-8">Social links</h2>;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    let t13;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <TelegramLink link={process.env.NEXT_PUBLIC_TG_CHANNEL_LINK || ""} label="Channel" />;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    let t14;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <TelegramLink link={process.env.NEXT_PUBLIC_TG_COMMUNITY_CHAT_LINK || ""} label="Community Chat" />;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    let t15;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <TelegramLink link={process.env.NEXT_PUBLIC_TG_BOT_LINK || ""} label="Bot" />;
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    let t16;
    let t17;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <div className="relative w-full flex items-stre justify-between gap-8 flex-wrap">{t13}{t14}{t15}<RedditLink link={process.env.NEXT_PUBLIC_REDDIT_LINK || ""} label="Reddit" /></div>;
      t17 = <h2 className="text-center text-2xl p-8">Alpha (Leader) Social links</h2>;
      $[28] = t16;
      $[29] = t17;
    } else {
      t16 = $[28];
      t17 = $[29];
    }
    let t18;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <TelegramLink link={process.env.NEXT_PUBLIC_ALPHA_TG_LINK || ""} label="Telegram" />;
      $[30] = t18;
    } else {
      t18 = $[30];
    }
    let t19;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <TelegramLink link={process.env.NEXT_PUBLIC_ALPHA_TG_CHANNEL_LINK || ""} label="Channel" />;
      $[31] = t19;
    } else {
      t19 = $[31];
    }
    let t20;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <TelegramLink link={process.env.NEXT_PUBLIC_ALPHA_TG_COMMUNITY_CHAT_LINK || ""} label="Community Chat" />;
      $[32] = t20;
    } else {
      t20 = $[32];
    }
    let t21;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <TelegramLink link={process.env.NEXT_PUBLIC_ALPHA_TG_BOT_LINK || ""} label="AI Assistant" />;
      $[33] = t21;
    } else {
      t21 = $[33];
    }
    let t22;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <XLink link={process.env.NEXT_PUBLIC_ALPHA_X_LINK || ""} label="X (Twitter)" />;
      $[34] = t22;
    } else {
      t22 = $[34];
    }
    let t23;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = <SplashScreen isBrowser={true}>{t10}{t11}<div className="mx-4">{t12}{t16}{t17}<div className="relative w-full flex items-start justify-around gap-8 flex-wrap">{t18}{t19}{t20}{t21}{t22}<RedditLink link={process.env.NEXT_PUBLIC_ALPHA_REDDIT_LINK || ""} label="Reddit" /></div></div></SplashScreen>;
      $[35] = t23;
    } else {
      t23 = $[35];
    }
    return t23;
  }
  if (!isReady) {
    let t4;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <LoadingScreen isBrowser={false} />;
      $[36] = t4;
    } else {
      t4 = $[36];
    }
    return t4;
  }
  let t4;
  if ($[37] !== children) {
    t4 = <TelegramProviderContent>{children}</TelegramProviderContent>;
    $[37] = children;
    $[38] = t4;
  } else {
    t4 = $[38];
  }
  return t4;
}
function _temp() {
  if (!isTMA()) {
    return;
  }
  init();
  if (miniApp.isSupported() && !miniApp.isMounted()) {
    miniApp.mount();
  }
  if (!viewport.isMounted()) {
    viewport.mount();
  }
  if (!themeParams.isMounted()) {
    themeParams.mount();
  }
  if (!closingBehavior.isMounted()) {
    closingBehavior.mount();
  }
  if (swipeBehavior.isSupported() && !swipeBehavior.isMounted()) {
    swipeBehavior.mount();
  }
  if (backButton.isSupported() && !backButton.isMounted()) {
    backButton.mount();
  }
  if (!mainButton.isMounted()) {
    mainButton.mount();
  }
  if (secondaryButton.isSupported() && !secondaryButton.isMounted()) {
    secondaryButton.mount();
  }
  if (settingsButton.isSupported() && !settingsButton.isMounted()) {
    settingsButton.mount();
  }
  if (locationManager.isSupported() && !locationManager.isMounted()) {
    locationManager.mount();
  }
  if (biometry.isSupported() && !biometry.isMounted()) {
    biometry.mount();
  }
  initData.restore();
}